import { trackAthenaImpression } from '@/common/analytics/athena/trackImpression';
import { trackGA4ViewItemList } from '@/common/analytics/gtm/item/trackViewItemList';
import { trackUAProductImpression } from '@/common/analytics/gtm/product/trackProductImpression';
import { EventMessage } from '@/common/analytics/gtm/types';

export const masonryDefaultImpressionHandler = (impressionMessage: EventMessage[]): void => {
  trackGA4ViewItemList(impressionMessage);
  trackUAProductImpression(impressionMessage);
  trackAthenaImpression(impressionMessage);
};
